import axios from "axios";

export const extractPoFromPdf = async (file, customerIdHint) => {
  const fd = new FormData();
  fd.append("file", file);
  if (customerIdHint) fd.append("customer_id_hint", customerIdHint);
  const { data } = await axios.post("po-ingest/extract", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const getPoIngestion = async (id) => {
  const { data } = await axios.get(`po-ingest/${id}`);
  return data;
};

export const patchPoItem = async (id, payload) => {
  const { data } = await axios.post(`po-ingest/${id}/patch-item`, payload);
  return data;
};

export const linkPoIngestion = async (id, payload) => {
  const { data } = await axios.post(`po-ingest/${id}/link`, payload);
  return data;
};

export const deletePoIngestion = async (id) => {
  const { data } = await axios.delete(`po-ingest/${id}`);
  return data;
};
